import { PipesModule } from './../../common/pipes/pipes.module';
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ApiUrl } from "../../api/api-url.service";
import { DirectivesModule } from './../../common/directives/directives.module';
import { ListComponent } from "./list/list.component";
import { ProductRoutingModule } from './product-routing.module';
import { EditComponent } from './edit/edit.component';
import { DetailComponent } from './detail/detail.component';
import { CreateComponent } from './create/create.component';
import { WizardComponent } from './wizard/wizard.component';
import { GhostComponent } from './ghost/ghost.component';
import { NgSelectModule } from '@ng-select/ng-select';
import {SweetAlert2Module} from "@toverux/ngx-sweetalert2";
import {PrintTemplateModule} from "../../common/print-template/print-template.module";
import {TemporaryPriceComponent} from "./temporary-price/temporary-price.component";
import { SortablejsModule } from 'angular-sortablejs';

@NgModule({
  imports: [
    CommonModule,
    ProductRoutingModule,
    HttpClientModule,
    SortablejsModule,
    FormsModule,
    DirectivesModule,
    PipesModule,
    NgSelectModule,
    SweetAlert2Module,
    PrintTemplateModule
  ],
  providers: [ApiUrl],
  declarations: [
    ListComponent,
    EditComponent,
    DetailComponent,
    CreateComponent,
    WizardComponent,
    GhostComponent,
    TemporaryPriceComponent
  ]
})
export class ProductModule {}
